<template>
    <el-dialog width="900px" :visible.sync="open" title="实验日志" @close="closeDialog" class="shenbao-exp-log">
        <el-row style="margin-bottom:15px">
            <el-col :span="7">
                <el-select v-model="logVal" clearable placeholder="请选择" size="small" @change="handLogChange">
                    <el-option v-for="item in expNameList" :key="item.uid" :label="item.name" :value="item.uid"></el-option>
                    <el-pagination layout="prev, pager, next" :total="expPage.total" @current-change="handExpPageChange" :current-page="expPage.page" :page-size="expPage.limit" hide-on-single-page></el-pagination>
                </el-select>
            </el-col>
            <el-col :span="13">
                <el-date-picker size="small" v-model="logDayVal" :picker-options="pickerOptions" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" @change="handLogChange"></el-date-picker>
            </el-col>
            <el-col :span="4">
                <el-button size="small" type="success" @click="exportLog" v-if="curSearchKey=='exp'">导出实验日志</el-button>
                <el-button size="small" type="success" @click="exportNoExpLog" v-if="curSearchKey=='nExp'">导出未实验人员名单</el-button>
            </el-col>
        </el-row>
        <p class="exp-curSearchKey">
            <span v-for="(item,key) in screen" :key="key" @click="handCurSearchKey(key)" :class="{'active' : key === curSearchKey}">{{item}}</span>
        </p>
        <div v-if="curSearchKey==='exp'">
            <el-table :data="expLogData" style="width: 100%" height="350">
                <el-table-column prop="index" label="序号" align="center" width="80px"></el-table-column>
                <!-- <el-table-column prop="lessonName" label="课堂名称" align="center"></el-table-column> -->
                <el-table-column prop="expName" label="实验名称" align="center"></el-table-column>
                <el-table-column prop="nickname" label="实验学生" align="center"></el-table-column>
                <el-table-column prop="startTime" label="实验开始时间" align="center"></el-table-column>
                <el-table-column label="实验时长" align="center">
                    <template slot-scope="scope">
                        <span v-text="timeTrans(scope.row.timeSpending)"></span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top:15px">
                <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper"
                    :total="expLogPage.total" :current-page="expLogPage.page" :page-size="expLogPage.limit"
                    @current-change="handExpLogPageChange" hide-on-single-page>
                </el-pagination>
            </div>
        </div>
        <div v-else-if="curSearchKey==='nExp'">
            <el-table :data="expLogData" style="width: 100%" height="350">
                <el-table-column prop="username" label="账号" align="center"></el-table-column>
                <el-table-column prop="nickname" label="姓名" align="center"></el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>
<script>
import { exportExcel } from '@/api/common'
import { getExpLogList } from '@/api/lab/lab-exp-log'
import { specifyNotExpList } from '@/api/lab/lesson2user'
import {  getLabExps } from '@/api/lab/experiment'
import { formatterTime } from '@/utils/formatter'

export default {
    props:{
        lessonUid:{
            type: String,
            default: ''
        }
    },
    data(){
        return {
            open:false,
            screen: {
                exp: '实验详情',
                nExp: '未实验名单'
            },
            expLogPage: {
                page: 1,
                limit: 5,
                total: 0
            },
            expLogData: [],
            expPage:{
                page: 1,
                limit: 5,
                total: 0
            },
            expNameList:[],
            logDayVal:'',
            logVal:'',
            curSearchKey: '',
            pickerOptions: {
                onPick: ({maxDate, minDate}) => {
                    this.selectDate= minDate.getTime();
                    if (maxDate) {
                        this.selectDate= ''
                    }
                }, disabledDate: (time) => {
                    if (this.selectDate!== '') {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.selectDate- one;
                        const maxTime = this.selectDate+ one;
                        return time.getTime() < minTime || time.getTime() > maxTime
                    }
                }
            },
        }
    },
    methods:{
        closeDialog(){ //日志弹窗关闭
            this.logVal = ''
            this.logDayVal = ''
        },
        timeTrans  (second) {
            return formatterTime(second)
        },
        changeVisible (visible = false) {
            this.open = visible
            this.getExpList()
            this.handCurSearchKey()
        },
        getExpList () {
            const { page, limit } = this.expPage
            getLabExps(page, limit, { lessonUid: this.lessonUid, sidx: 'view_index, create_time DESC' }).then(res => {
                const { list = [], totalCount = 0 } = res
                this.$set(this.expPage, 'total', totalCount)
                this.expNameList = list
            });
        },
        handExpPageChange(page){
            this.$set(this.expPage, "page", page);
            this.getExpList()
        },
        handCurSearchKey (key) {  //切换部分
            let value = key
            if (!value || !this.screen[value]) {
                value = Object.keys(this.screen)[0]
            }
            this.curSearchKey = value
            switch (value) {
                case 'exp':
                    this.getExpLogList ()
                    break;
                case 'nExp':
                    this.specifyNotExpList()
                    break;
                default:
                    break;
            }
        },
        specifyNotExpList(){
            this.expLogData = []
            if(!this.logVal && !this.logDayVal) {
               this.$message.warning('请指定课程,以及时间段,用来查询时间段内未实验的学生名单!')
            }else if(this.logVal && this.logDayVal){
                let params = {
                    labExpUid:this.logVal,
                    startTime:this.logDayVal[0],
                    endTime:this.logDayVal[1],
                    lessonUid:this.lessonUid
                }
                specifyNotExpList(params).then(res=>{
                    this.expLogData = res
                })
            }
        },
        handLogChange(){  //分实验查看时
            this.expLogPage = {
                page: 1,
                limit: 5,
                total: 0
            }
            this.getExpLogList ()
        },
        exportNoExpLog(){
            let params = {
                lessonUid: this.lessonUid,
                sidx: 'id desc'
            }
            if(this.logDayVal && this.logVal){
                params = {
                    lessonUid: this.lessonUid,
                    labExpUid: this.logVal,
                    startTime: this.logDayVal[0],
                    endTime: this.logDayVal[1],
                    sidx: 'id desc'
                }
            }else{
                this.$message.warning('请选择时间范围,再完成导出名单!')
                return
            }
            exportExcel('lab/lesson2user/not/doexp/lessonusers', {  //导出未实验人员名单
                ...params
            })
        },
        handExpLogPageChange (page) { //实验日志弹窗翻页
            this.$set(this.expLogPage, "page", page);
            this.getExpLogList()
        },
        getExpLogList () { //获取实验日志列表
            let params = {
                lessonUid: this.lessonUid,
                sidx: 'id desc'
            }
            if(this.logVal){
                params.labExpUid = this.logVal
            }
            if(this.logDayVal){
                params.startTime = this.logDayVal[0]
                params.endTime = this.logDayVal[1]
            }
            const { page, limit } = this.expLogPage
            if(this.curSearchKey == 'exp'){
                getExpLogList(page, limit, params).then(res => {
                    const { totalCount, list } = res
                    this.expLogData = list
                    this.expLogData.forEach((item, index) => {
                        item.index = index + 1 + (page - 1) * limit
                        return item
                    })
                    this.$set(this.expLogPage, 'total', totalCount)
                })
            }else if(this.curSearchKey == 'nExp'){
                this.specifyNotExpList()
            }
        },
        exportLog(){
            let params = {}
            if(this.logVal && this.logDayVal){
                params = {
                    lessonUid: this.lessonUid,
                    labExpUid: this.logVal,
                    startTime: this.logDayVal[0],
                    endTime: this.logDayVal[1],
                    sidx: 'id desc'
                }
            }
            else{
                this.$message.warning('请选择相关实验及时间范围,再完成导出日志!')
                return
            }
            exportExcel('lab/labexperimentlog', {  //导出实验人员名单
                ...params
            })
        },
    }
}
</script>
<style lang="less">
.shenbao-exp-log{
    .exp-curSearchKey{
        height: 60px;
        text-align: center;
        font: 400 18px "微软雅黑";
        border-bottom: 1px solid #dcdcdc;
        padding-bottom: 12px;
        span {
            line-height: 60px;
            padding: 0 12px;
            color: #999;
            cursor: pointer;
        }
        span:nth-of-type(1) {
            border-right: 1px solid #969696;
        }
        .active {
            color: #14b14e;
        }
    }
}
</style>